export default __webpack_public_path__ + "static/media/login-bg-23.fe996cce.jpg";